import { OAuthService } from '@qdrant/qdrant-cloud-public-api/auth/v1/oauth';
import {
  createOAuthGrant,
  getOAuthConsentRequest,
  listAccountOAuthGrants,
  listMyOAuthGrants,
  revokeAccountOAuthGrant,
  revokeMyOAuthGrant,
} from '@qdrant/qdrant-cloud-public-api/auth/v1/oauth/connect-query';
import { transport } from '@/api/transport';
import {
  type MutationFactory,
  queryOptions,
  useMutation,
  createServiceQueries,
  createConnectQueryKey,
} from '@/connect-query';

export const oauthService = createServiceQueries(OAuthService, {
  listMyOAuthGrantsQuery: () => queryOptions(listMyOAuthGrants, undefined, { transport }),
  listAccountOAuthGrantsQuery: (params) => queryOptions(listAccountOAuthGrants, params, { transport }),
  // The session token is single-login and short-lived: never refetch it in the background.
  getOAuthConsentRequestQuery: (params) => ({
    ...queryOptions(getOAuthConsentRequest, params, { transport, select: (d) => d.consentRequest }),
    staleTime: Infinity,
    retry: false,
  }),
});

export const useRevokeMyOAuthGrantMutation: MutationFactory<typeof revokeMyOAuthGrant> = () =>
  useMutation(revokeMyOAuthGrant, {
    onSuccess: (_data, _variables, _onMutateResult, { client }) =>
      client.invalidateQueries({ queryKey: createConnectQueryKey({ schema: listMyOAuthGrants }) }),
  });

export const useRevokeAccountOAuthGrantMutation: MutationFactory<typeof revokeAccountOAuthGrant> = () =>
  useMutation(revokeAccountOAuthGrant, {
    onSuccess: (_data, { accountId }, _onMutateResult, { client }) =>
      client.invalidateQueries({
        queryKey: createConnectQueryKey({ schema: listAccountOAuthGrants, input: { accountId } }),
      }),
  });

export const useCreateOAuthGrantMutation: MutationFactory<typeof createOAuthGrant> = () =>
  useMutation(createOAuthGrant);
